export default __webpack_public_path__ + "static/media/ally_xl2.95d84148.png";